export class RtsDTO {
	codiceFiscale: string;
	codiceOrdinante: string;
	dataFine: Date;
	dataInizio: Date;
	denominazioneRTS: string;
	provinceCompetenza: Array<string>;
}